import { render } from "./BandLegend.vue?vue&type=template&id=6672fa37&scoped=true"
import script from "./BandLegend.vue?vue&type=script&lang=js"
export * from "./BandLegend.vue?vue&type=script&lang=js"

import "./BandLegend.vue?vue&type=style&index=0&id=6672fa37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6672fa37"]])

export default __exports__